import React from 'react';

const Card = ({
  children,
  variant = 'default',
  elevation = 1,
  style = {},
  className = '',
  onClick,
  ...props
}) => {
  const baseStyles = {
    backgroundColor: 'white',
    borderRadius: 'var(--border-radius-lg, 12px)',
    padding: 'var(--spacing-lg, 16px)',
    transition: 'all 0.2s ease-in-out',
    border: '1px solid #e0e0e0',
    ...style
  };

  const variantStyles = {
    default: {
      boxShadow: elevation > 0 ? `0 ${elevation * 2}px ${elevation * 4}px rgba(0,0,0,0.1)` : 'none',
    },
    interactive: {
      cursor: 'pointer',
      boxShadow: elevation > 0 ? `0 ${elevation * 2}px ${elevation * 4}px rgba(0,0,0,0.1)` : 'none',
    },
    outlined: {
      border: '2px solid var(--color-primary, #2a4d69)',
      boxShadow: 'none',
    }
  };

  const finalStyles = {
    ...baseStyles,
    ...variantStyles[variant]
  };

  const handleMouseEnter = (e) => {
    if (variant === 'interactive') {
      e.target.style.transform = 'translateY(-2px)';
      e.target.style.boxShadow = '0 8px 16px rgba(0,0,0,0.15)';
    }
  };

  const handleMouseLeave = (e) => {
    if (variant === 'interactive') {
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = elevation > 0 ? `0 ${elevation * 2}px ${elevation * 4}px rgba(0,0,0,0.1)` : 'none';
    }
  };

  return (
    <div
      style={finalStyles}
      className={className}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
